export default {
    // Source of Thruth for all reconciliation page
    namespaced: true,
    state: {
        // Build from listingV2 backend. Contains obj with
        // docid, thirdname, ident, displayedDate, step,
        // totalAmount and dueAmount
        docs: [],
        // Display loader during document fetch
        loadingDocs: false,
        // Build from listingV2 backend. Contains
        // current_page, last_page, per_page and total
        pagination: {
            per_page: 25,
        },
        // To process and for the summary panel. Contains obj with
        // docid, paymentid or paymentAmount + payment ref and deadlineId.
        // Need also a unique id to delete a reconciliation directly
        reconciled: [],
        // current doctype for doc listing
        doctype: null,
        // current transaction date
        transactionDate: null,
        // current transaction amount
        transactionAmount: 0,
        transactionReconciledAmount: 0,
        transactionRemainingReconciledAmount: 0,
        transactionType: null,
        transactionCurrencySymbol: null,

        doctypesDirection: {
            invoice: 'credit',
            creditnote: 'debit',
            purInvoice: 'debit',
            purCreditNote: 'credit',
        },
    },
    getters: {
        docs: (state) => state.docs,
        loadingDocs: (state) => state.loadingDocs,
        pagination: (state) => state.pagination,
        reconciled: (state) => state.reconciled,
        doctype: (state) => state.doctype,
        transactionId: (state) => state.transactionId,
        transactionDate: (state) => state.transactionDate,
        transactionAmount: (state) => state.transactionAmount,
        transactionReconciledAmount: (state) => state.transactionReconciledAmount,
        transactionRemainingReconciledAmount: (state) => state.transactionRemainingReconciledAmount,
        transactionType: (state) => state.transactionType,
        transactionCurrencySymbol: (state) => state.transactionCurrencySymbol,
        doctypeDirection: (state) => {
            return state.doctypesDirection[state.doctype] || null;
        },
    },
    mutations: {
        docsLoading(state) {
            state.loadingDocs = true;
        },
        docsLoaded(state) {
            state.loadingDocs = false;
        },
        setDocs(state, docs) {
            state.docs = docs;
        },

        setPagination(state, pagination) {
            state.pagination = pagination;
        },
        addReconciled(state, reconciliation) {
            state.reconciled.push(reconciliation);
        },
        delReconciled(state, id) {
            state.reconciled = state.reconciled.filter((reconciled) => {
                return reconciled.id != id;
            });
        },
        setDoctype(state, doctype) {
            state.doctype = doctype;
        },
        setTransactionId(state, transactionId) {
            state.transactionId = transactionId;
        },
        setTransactionDate(state, transactionDate) {
            state.transactionDate = transactionDate;
        },
        setTransactionAmount(state, transactionAmount) {
            state.transactionAmount = transactionAmount;
        },
        setTransactionReconciledAmount(state, transactionReconciledAmount) {
            state.transactionReconciledAmount = transactionReconciledAmount;
        },
        setTransactionRemainingReconciledAmount(state, transactionRemainingReconciledAmount) {
            state.transactionRemainingReconciledAmount = transactionRemainingReconciledAmount;
        },
        setTransactionType(state, transactionType) {
            state.transactionType = transactionType;
        },
        setTransactionCurrencySymbol(state, currencySymbol) {
            state.transactionCurrencySymbol = currencySymbol;
        },
    },
};
